<template>
  <div>
    <side-bar>
      <!-- Header bar -->
      <template v-slot:header>
        <v-toolbar-title style="font-size: 16px;">Lists</v-toolbar-title>
        <v-spacer></v-spacer>  
        <v-btn icon dark color="deep-orange"  
          @click.stop="open_add" 
          v-if="$is_privilege(['root', 'developer', 'admin', 'group_admin', 'device_admin'])"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </template>

      <!-- Search -->
      <template v-slot:subheader>
          <v-text-field flat solo hide-details color="deep-orange"
            label="Search" 
            prepend-inner-icon="search"
            v-model="search"
            clearable
            @click:clear="clear_search"
          ></v-text-field>
      </template>

      <!-- Pinned lists -->
      <div class="mt-1 mb-1" v-if="pinned_lists.length > 0">        
        <li class="list-tile" v-for="list in pinned_lists">
          <v-btn icon class="list-btn"> 
            <v-icon color="deep-orange" @click.stop="unpin(list.id)">push_pin</v-icon> 
          </v-btn>

          <button class="list-content" @click.stop="open_list(list.id)">
            <div class="list-id" >
              {{ list.id }}
            </div>

            <div class="list-name">
              <div> {{ list.name }} </div>
              <div style="color: lightgray; font-size: 11px">
                {{ get_path_string(list.id) }} 
              </div>
            </div>
          </button>

          <v-btn icon class="list-btn" 
            @click.stop="open_edit(list.id)" 
            v-if="$is_privilege(['root', 'developer', 'admin', 'group_admin', 'device_admin'])"
          ><v-icon>edit</v-icon></v-btn>
        </li>
      </div>
      <v-divider v-if="pinned_lists.length > 0"></v-divider>

      <!-- Treeview -->
      <v-card class="pt-0" flat>
        <v-treeview activatable hoverable
          :active.sync="active" 
          :open="open_lists" 
          :search="search_value" 
          :items="tree" 
          v-if="all_lists.length"
        >
          <template slot="prepend" slot-scope="{ item }">
            <button> {{ item.id }} </button>
          </template>
          <template slot="label" slot-scope="{ item }">
            <button> {{ item.name }} </button>
          </template>
          <template slot="append" slot-scope="{ item }" >
            <v-btn 
              v-if="$is_privilege(['root', 'developer', 'admin', 'group_admin', 'device_admin'])"small 
              icon 
              @click.stop.prevent="open_edit(item.id)"
            ><v-icon>edit</v-icon></v-btn>
          </template>
        </v-treeview>
      </v-card>

    </side-bar>
    <BottomSheet></BottomSheet>
  </div>
</template>

<script>
import BottomSheet from '../BottomSheet'
import SideBar from '@/components/SideBar.vue'

export default {
  props: ["id"],
  components: {
    BottomSheet,
    SideBar
  },
  data () {
    return {
      search_value: ""
    }
  },
  computed: {
    search: {
      get() { return this.search_value; },
      set: _.debounce(function (value) {
        this.search_value = (value) ? value : "";
      }, 250)
    },
    active: {
      get() {
        return (typeof(this.id) != "undefined") ? this.get_path_list(parseInt(this.id), true) : [];
      },
      set(val) {
        if(val.length > 0 && this.id != val[0]) {
          this.active = this.get_path_list(val[0]);
          this.open_list(val[0]);
        };
      }
    },
    pinned_lists() {
      if(_.isEmpty(this.indexed_lists)) return [];
      let ids = _.get(this.$store.state.account, 'meta.cms_pinned_lists', []);
      let lists = [];
      ids.forEach((id) => lists.push(this.indexed_lists[id]));
      return lists;
    },
    open_lists () {
      let open = [];
      if(this.search.length > 1) {
        open = this.open_filtered();
      }; 
      return open.concat(this.active);
    },
    tree () {
      const lists = this.indexed_lists;
      let tree = [];
      this.all_lists.forEach(list => {
        if(list.meta.parent_list_id != undefined) {
          if(lists[list.meta.parent_list_id]) {
            lists[list.meta.parent_list_id].children.push(lists[list.id])
          } else {
            tree.push(lists[list.id]);
          };
        } 
        else tree.push(lists[list.id]);
      });
      return tree;
    },
    indexed_lists () {
      let indexed_lists = {};
      this.all_lists.forEach(list => indexed_lists[list.id] = {...list, children: []});
      return indexed_lists;
    },
    all_lists () {
      let lists = Object.values(this.$store.state.cms_lists);
      if(this.$is_privilege(["developer"])) {
        return lists;
      }
      return _.filter(lists, (list) => { return list.meta.system != true; });
    }
  },
  mounted() {
    this.$store.dispatch("get_profile");
  },
  methods: {
    open_list (id) {
      if(this.$router.currentRoute.params.id != id) {
        this.$router.push("/content/list/"+id);
      }
    },
    open_edit (id) {
      this.$router.push("/content/list/"+id+"/edit");
    },
    open_add () {
      this.$router.push("/content/list/"+this.id+"/new");
    },
    clear_search () {
      this.search = "";
    },
    open_filtered () {
      let filtered_open = new Set();
      for(const list of this.all_lists) {
        if(list.name.toLowerCase().includes(this.search.toLowerCase())) {
          let path = new Set(this.get_path_list(list.id));
          filtered_open = filtered_open.union(path);
        };
      };
      return Array.from(filtered_open);
    },
    get_path_string (id) {
      let path_list = this.get_path_list(id);
      let path_string = "";
      path_list.forEach((id) => path_string = " / " + this.indexed_lists[id].name + path_string);
      return path_string;
    },
    get_path_list (list_id, include_list = false) {
      if(!list_id) return [];

      const indexed_lists = this.indexed_lists;
      const list = indexed_lists[list_id];
      let parent = indexed_lists[list.meta.parent_list_id];
      let path = [];
      while (parent !== undefined) {
        path.push(parent.id);
        parent = indexed_lists[parent.meta.parent_list_id];
      };
      if(include_list) { path.push(list_id) };
      return path;
    },
    unpin (id) {
      if (!this.$store.state.account) return;
      let acc = _.cloneDeep(this.$store.state.account);
      acc.meta.cms_pinned_lists = _.xor(acc.meta.cms_pinned_lists, [id]);
      this.$store.dispatch("update_profile", acc);
    }
  }
}
</script>

<!-- Pinned lists -->
<style scoped>
  .list-tile {
    white-space: nowrap;
    height: 38px;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-weight: 500;
    width: fit-content;
    gap: 2px;
  }
  .list-btn {
    width: 27px;
    height: 27px;
    margin-left: 3px;
    margin-right: 0px;
  }
  .list-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    min-width: 277px;
    gap: 2px;
  }
  .list-id {
    display: flex;
    min-width: 34px;
  }
  .list-name {
    width: fit-content;
    font-size: 13px;
    white-space: nowrap;
    justify-items: start;
  }
</style>

<style>
  .v-treeview-node__label, .v-treeview-node__content {
    font-size: 13px !important;
    font-weight: 500;
  }
</style>